import * as accountsApi from '@/network/api/accounts.api.js'
import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as cardTopupApi from '@/network/api/cardtopup.api.js'

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
@return {promise} - Accounts Balances
*/
export const requestAccounts = async (context, payload) => {
	const res = await accountsApi.requestAccountsBalances(payload)

	if (res) context.commit('SAVE_ACCOUNTS', res.data.data)
	return res
}

/** requests Cards List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
	const res = await cardsApi.cards(payload)

	if (res) context.commit('SAVE_CARDS', res.data.data)
	return res
}

/** requests Card Group Plafond
@docs
@return {promise} - Card Group Plafond
*/
export const requestCardGroupPlafond = async (context, payload) => {
	const res = await cardTopupApi.requestCardGroupPlafond(payload)

	if (res) context.commit('SAVE_CARD_GROUP_PLAFOND', res.data.data)
	return res
}

/** requests Last Batchfile Charge List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchFiles
@return {promise} - last batchfile charge list
*/
export const requestLastBatchfileChargeList = async (context, payload) => {
	const res = await cardTopupApi.requestBatchfileChargesList(payload)

	if (res) context.commit('SAVE_LAST_BATCHFILE_CHARGE_LIST', res.data.list)
	return res
}

/** submit uploaded file with batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcardtopupbatchFilesbatchFilesubmit
@return {promise} - file uploaded info
*/
export const submitUploadedBatchfileRequest = async (context, payload) => {
	const res = await cardTopupApi.submitUploadedBatchfile(payload)
	return res
}

/** submit manual batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcardtopupbatchFilesbatchFilesubmitmanual
@return {promise} - manual batchfile charge info
*/
export const submitManualBatchfileChargeRequest = async (context, payload) => {
	const res = await cardTopupApi.submitManualBatchfileCharge(payload)
	return res
}

/** aprove batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_internetcardtopupbatchFiles%7BbatchFileId%7Dapprove
@return {promise} - aprove batchfile charge response
*/
export const aproveBatchfileChargeRequest = async (context, payload) => {
	const res = await cardTopupApi.aproveBatchfileCharge(payload)
	return res
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
